// extracted by mini-css-extract-plugin
export default {"tabBar":"TabBar_tabBar__EX2VI"};